import Placemark1Icon from './component'

export default Placemark1Icon
